import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormAnnouncement from '../../forms/FormAnnouncement.jsx';

const PageAnnouncement = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: `/api/site/announcements/${_id}`,
    });
  }, [_id]);

  const breadcrumb = [
    { to: '../', children: 'Announcements' },
  ];

  return (
    <>
      {_id === 'new' ? (
        <div>
          <Header breadcrumb={breadcrumb}>Create New</Header>
          <FormAnnouncement />
        </div>
      ) : (
        <PageHttp res={res}>
          {(doc) => (
            <>
              <Header breadcrumb={breadcrumb}>Editor</Header>
              <FormAnnouncement announcement={doc} />
            </>
          )}
        </PageHttp>
      )}
    </>
  );
};

export default PageAnnouncement;
